import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import { PropType } from "vue";

import { getIdentifierTypeName, getIdentifierState } from "@/constants";
import { IIdentifier, IService } from "@/types/identifier";
import { useIdentifiers } from "@/use/useIdentifiers";
import { formatCurrency } from "@/utils";
import { useStore } from "@/use/useStore";

import UiCard from "@/plugins/ui/components/card/UiCard.vue";
import UiCell from "@/plugins/ui/components/cell/UiCell.vue";
import UiHeader from "@/plugins/ui/components/header/UiHeader.vue";

import UiSwitch from "@/components/ui/UiSwitch.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'IdentifierCard',
  props: {
  identifier: {
    type: Object as PropType<IIdentifier & { services: IService[] }>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const { currentUser } = useStore();
const { updateIdentifier } = useIdentifiers();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiCard, null, {
    header: _withCtx(() => [
      _createVNode(UiHeader, {
        title: _unref(getIdentifierTypeName)(__props.identifier.type),
        description: _unref(getIdentifierState)(__props.identifier.state)
      }, {
        right: _withCtx(() => [
          _createElementVNode("p", {
            class: _normalizeClass(["text-xs", __props.identifier.active ? 'text-green-500' : 'text-red-500'])
          }, _toDisplayString(__props.identifier.active ? "Активен(-на)" : "Заблокирован(-на)"), 3)
        ]),
        _: 1
      }, 8, ["title", "description"])
    ]),
    default: _withCtx(() => [
      _createVNode(UiCell, { title: "Заблокировать" }, {
        right: _withCtx(() => [
          _createVNode(UiSwitch, {
            "model-value": !__props.identifier.active,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (
              _unref(updateIdentifier)(__props.identifier, { active: !$event })
            ))
          }, null, 8, ["model-value"])
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.identifier.services, (service) => {
        return (_openBlock(), _createBlock(UiCell, {
          key: service.id,
          title: service.name,
          href: `https://z.edu28.ru/pay?score_id=${_unref(currentUser)?.score_id}&service_id=${service.id}&target=${service.target}`,
          target: "_blank",
          rel: "noreferrer",
          multiline: "",
          expandable: ""
        }, {
          right: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_unref(formatCurrency)(service.price / 100)), 1)
          ]),
          _: 2
        }, 1032, ["title", "href"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})